import { useRef } from "react";
import { Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import classes from "../../maintainers.module.scss";

const TabURLs = ({ data, setData }) => {
	const { addToast } = useToasts();

	const refFileTag = useRef(null);
	const refFileBrochure = useRef(null);
	const refFileDataSheet = useRef(null);
	const refFileSafetySheet = useRef(null);

	// funcion para guardar archivos en base64 y que sea variable el atributo de data donde se guarda
	const handleSaveFile = async (e, attribute) => {
		const files = e.target.files;

		if (files && files.length !== 0) {
			let newData = { ...data };

			if (files[0].size / 1024 / 1024 < 5) {
				const base64_file = await new Promise((resolve, reject) => {
					if (files[0]) {
						const reader = new FileReader();
						reader.readAsDataURL(files[0]);
						reader.onload = () => resolve(reader.result);
						reader.onerror = (error) => reject(error);
					}
				});

				newData[attribute] = base64_file;
				newData[`${attribute}_our`] = true;
				newData[`${attribute}_name`] = files[0].name;

				setData(newData);
			} else {
				addToast("El documento supera el peso máximo permitido (5MB).", {
					appearance: "error",
				});
			}
		}
	};

	return (
		<Row className={classes.row_form} style={{ marginTop: "10px" }}>
			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>URL Etiqueta</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							value={data.url_tag_our !== "0" ? data.url_tag_name : data.url_tag ? data.url_tag : ""}
							onChange={(e) =>
								setData({
									...data,
									url_tag: e.currentTarget.value,
								})
							}
							type="text"
							readOnly={data.url_tag_our !== "0" ? true : false}
						/>
						<input style={{ display: "none" }} type="file" ref={refFileTag} onChange={(e) => handleSaveFile(e, "url_tag")} />
						<Button
							variant="outline-secondary"
							style={{ marginLeft: "2px", marginRight: "2px" }}
							onClick={(_e) => refFileTag.current && refFileTag.current.click()}
						>
							Subir Archivo
						</Button>
						{data.private_url_tag && !data.private_url_tag.includes("base64") && (
							<Button
								variant="outline-success"
								style={{ marginLeft: "2px", marginRight: "2px" }}
								onClick={(_e) => data.private_url_tag && window.open(data.private_url_tag, "_blank")}
							>
								Descargar
							</Button>
						)}
					</InputGroup>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>URL Ficha Técnica</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							value={data.url_data_sheet_our !== "0" ? data.url_data_sheet_name : data.url_data_sheet ? data.url_data_sheet : ""}
							onChange={(e) =>
								setData({
									...data,
									url_data_sheet: e.currentTarget.value,
								})
							}
							type="text"
							readOnly={data.url_data_sheet_our !== "0" ? true : false}
						/>
						<input style={{ display: "none" }} type="file" ref={refFileDataSheet} onChange={(e) => handleSaveFile(e, "url_data_sheet")} />
						<Button
							variant="outline-secondary"
							style={{ marginLeft: "2px", marginRight: "2px" }}
							onClick={(_e) => refFileDataSheet.current && refFileDataSheet.current.click()}
						>
							Subir Archivo
						</Button>
						{data.private_url_data_sheet && !data.private_url_data_sheet.includes("base64") && (
							<Button
								variant="outline-success"
								style={{ marginLeft: "2px", marginRight: "2px" }}
								onClick={(_e) => data.private_url_data_sheet && window.open(data.private_url_data_sheet, "_blank")}
							>
								Descargar
							</Button>
						)}
					</InputGroup>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>URL Hoja de Seguridad</Form.Label>

					<InputGroup className="mb-3">
						<Form.Control
							value={data.url_safety_sheet_our !== "0" ? data.url_safety_sheet_name : data.url_safety_sheet ? data.url_safety_sheet : ""}
							onChange={(e) =>
								setData({
									...data,
									url_safety_sheet: e.currentTarget.value,
								})
							}
							type="text"
							readOnly={data.url_safety_sheet_our !== "0" ? true : false}
						/>
						<input style={{ display: "none" }} type="file" ref={refFileSafetySheet} onChange={(e) => handleSaveFile(e, "url_safety_sheet")} />
						<Button
							variant="outline-secondary"
							style={{ marginLeft: "2px", marginRight: "2px" }}
							onClick={(_e) => refFileSafetySheet.current && refFileSafetySheet.current.click()}
						>
							Subir Archivo
						</Button>
						{data.private_url_safety_sheet && !data.private_url_safety_sheet.includes("base64") && (
							<Button
								variant="outline-success"
								style={{ marginLeft: "2px", marginRight: "2px" }}
								onClick={(_e) => data.private_url_safety_sheet && window.open(data.private_url_safety_sheet, "_blank")}
							>
								Descargar
							</Button>
						)}
					</InputGroup>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>URL Folleto</Form.Label>
					<InputGroup className="mb-3">
						<Form.Control
							value={data.url_brochure_our !== "0" ? data.url_brochure_name : data.url_brochure ? data.url_brochure : ""}
							onChange={(e) =>
								setData({
									...data,
									url_brochure: e.currentTarget.value,
								})
							}
							type="text"
							readOnly={data.url_brochure_our !== "0" ? true : false}
						/>
						<input style={{ display: "none" }} type="file" ref={refFileBrochure} onChange={(e) => handleSaveFile(e, "url_brochure")} />
						<Button
							variant="outline-secondary"
							style={{ marginLeft: "2px", marginRight: "2px" }}
							onClick={(_e) => refFileBrochure.current && refFileBrochure.current.click()}
						>
							Subir Archivo
						</Button>

						{data.private_url_brochure && !data.private_url_brochure.includes("base64") && (
							<Button
								variant="outline-success"
								style={{ marginLeft: "2px", marginRight: "2px" }}
								onClick={(_e) => data.private_url_brochure && window.open(data.private_url_brochure, "_blank")}
							>
								Descargar
							</Button>
						)}
					</InputGroup>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default TabURLs;
